import pic11 from "../../assets/images/Ads/clinic1.jpg";
import pic12 from "../../assets/images/Ads/clinic2.jpg";
import pic13 from "../../assets/images/Ads/clinic3.jpg";
import pic4 from "../../assets/images/Ads/clinic4.jpg";
import pic5 from "../../assets/images/Ads/clinic5.jpg";
import pic6 from "../../assets/images/Ads/clinic6.jpg";
import pic7 from "../../assets/images/Ads/clinic7.jpg";
import pic8 from "../../assets/images/Ads/clinic8.jpg";
import pic9 from "../../assets/images/Ads/clinic9.jpg";
import pic10 from "../../assets/images/Ads/clinic10.jpg";
import pic1 from '../../assets/images/Ads/alfa lab.png';
import pic2 from '../../assets/images/Ads/borj lab.png';
import pic3 from '../../assets/images/Ads/mokhtabar lab.jpg';
let adsData = [
	{
		id: 1,
		imgSrc: pic11,
		title: 'Dr. Osama Saad',
		info: 'you are safe with us',
		phone: '0154789655-01154858854',
	},
	{
		id: 2,
		imgSrc: pic12,
		title: 'Dr. Alaa Hamdy',
		info: 'best place to care about your health',
		phone: '01598899954',
	},
	{
		id: 3,
		imgSrc: pic13,
		title: 'Dr. Sandro Samy',
		info: 'your health need professional doctors',
		phone: '0154789655-01154858854',
	},
	{
		id: 4,
		imgSrc: pic4,
		title: 'Dr. Dina Said',
		info: 'Best clinics in egypt',
		phone: '0154789655-01154858854',
	},
	{
		id: 5,
		imgSrc: pic5,
		title: 'Dr. Mohamed Gamal',
		info: 'More than 10 years of experience',
		phone: '0154789655-01154858854',
	},
	{
		id: 6,
		imgSrc: pic6,
		title: 'Dr. Saleh Saad',
		info: 'We know how to care about you',
		phone: '0154789655-01154858854',
	},
	{
		id: 7,
		imgSrc: pic7,
		title: 'Dr. Ahmed Megahed',
		info: 'Efficiency and proficiency',
		phone: '0154789655-01154858854',
	},
	{
		id: 8,
		imgSrc: pic8,
		title: 'Dr. Youssef Mohamed',
		info: 'Never mind about your health',
		phone: '0154789655-01154858854',
	},
	{
		id: 9,
		imgSrc: pic9,
		title: 'Dr. Leen Mohamed',
		info: 'It is much easier than before',
		phone: '0154789655-01154858854',
	},
	{
		id: 10,
		imgSrc: pic10,
		title: 'Dr. Nagham Saleh',
		info: 'Over 15 years of experience',
		phone: '0154789655-01154858854',
	},
	{
		id: 11,
		imgSrc: pic1,
		title: 'Alfa Labs',
		info: 'Alfa labs is your place',
		phone: '01154847125',
	},
	{
		id: 12,
		imgSrc: pic2,
		title: 'Elborj Labs',
		info: 'Elborj labs is in your service',
		phone: '01258736948-01258736954',
	},
	{
		id: 13,
		imgSrc: pic3,
		title: 'Elmokhtabar Labs',
		info: 'Elmokhtabar labs the best labs in egypt',
		phone: '0154789655',
	},
];
export default adsData